export enum CommunicationHistoryDetailTabs {
  SENDREPORT = "SEND REPORT",
  MESSAGECONTENT = "MESSAGE CONTENT",
}
